import { UploadModal } from './UploadModal'

export const Modal = {
  Upload: UploadModal,
}
